import type { IconSvgObject } from './types';

const UnfoldMoreIcon: IconSvgObject = [
  ["path", { d: "M18 14C18 14 13.5811 19 12 19C10.4188 19 6 14 6 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 9.99996C18 9.99996 13.5811 5.00001 12 5C10.4188 4.99999 6 10 6 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UnfoldMoreIcon;
